// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"InputError_btn-primary__3P9NO","root":"InputError_root__2LFwS"};